import { useFormik } from "formik";
import { useState } from "react";
import logout from "../../../utils/Logout";
import Swal from "sweetalert2";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { NuInput } from "../../../utils/Inputs";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";


export default function CreateOrUpdate({
    visible,
    onClose,
    refreshData,
    id,
  }) {
    const { isCreateLoading, addData } = useAddData();
    const [createNew, setCreateNew] = useState({
        standard_id:"",
        product_access:""
      });

      const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (value,{resetForm}) => {
            value.standard_id = id
            addData({
                url: "/standard_tokens/checking",
                value: value,
                resetForm: resetForm,
                onClose: onClose,
                getData: refreshData,
                otherFunction:handleReset
              });
        },
      });

      const handleReset = async () => {
        Swal.fire({
          title: 'Please Logout',
          text: `New Subscription change will be implemented only after user logout. Please logout and Re-login to start using MetaSCROLL application.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#DEDEDE',
          confirmButtonText: 'Logout'
        }).then(async (result) => {
          if (result.isConfirmed) {
            logout()
          }
        })
      }
    
      if (!visible) return null;
      const resetClose = () => {
        formik.resetForm();
        onClose();
      };
      return (
        <>
              <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center  h-auto"
      >
        <div className="bg-white mt-12 p-2 h-auto rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
             New Subscription
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative max-h-[calc(100vh-180px)] flex flex-wrap justify-between text-left">
            <NuInput
                  label="Please Enter the 16 digit Subscription Key"
                  name="product_access"
                  formik={formik}
                  placeholder="ABCD-EFGH-IJKL-MNOP"
                  width="w-full"
                />

              <div className=" w-full flex items-center justify-end px-3 py-6 rounded-b">
                <CancelButton onClose={resetClose} isLoading={isCreateLoading} />
                <SubmitButton isLoading={isCreateLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
        </>
      )
  }